export default __webpack_public_path__ + "static/media/pxgroup06.850815e3.png";